import { CouponFilterPage } from "./couponFilter/CouponFilterPage";
import { CouponTablePage } from "./couponTable/CouponTablePage";

import classes from "./couponListPage.module.css";



export const CouponListPage = () => {
  return (
    <div className={classes.box}>
      <CouponFilterPage />
      <CouponTablePage />
    </div>
  );
};
